export const environment = {
	production: false,
	ssl: true,
	restServer: 'duellino-api.rechnerha.us',
	restServerPort: 443,
	isApp: true,
	deeplinkHost: 'https://duellino.rechnerha.us',
	websiteUrl: 'https://duellino.rechnerha.us',
	oneSignalAppId: '548474e5-0dbc-405d-b854-97c28b486eaa',
};
